:host li {
  all: unset;
  all: reset;
  width: 100%;
  line-height: 14px;
  list-style-type: none;
}

:host li > span {
  display: flex;
  padding: calc(var(--space-unit) * 2) 0;
  color: var(--color-default-text);
  fill: var(--color-default-icon);
  font-family: var(--font-family-sans);
  font-size: 16px;
  font-weight: var(--font-rg);
  letter-spacing: 0.23px;
  line-height: 14px;
}

:host(.small) li > span {
  padding: calc(var(--space-unit) * 1.5) 0;
  font-size: var(--font-size-2);
}

:host(.x-small) li > span {
  padding: var(--space-unit) 0;
  font-size: var(--font-size-2);
}

:host(.small) li > span > z-icon,
:host(.x-small) li > span > z-icon {
  --z-icon-width: 16px;
  --z-icon-height: 16px;
  --z-icon-right-margin: calc(var(--space-unit) * 0.5);

  padding: 0;
}

:host li > span.border {
  border-bottom: 2px solid var(--color-surface03);
}

:host li span:hover,
a:hover {
  color: var(--color-primary01);
  fill: var(--color-primary01);
}

a,
a:visited,
a:active {
  color: inherit;
  fill: inherit;
  text-decoration: none;
}

:host li span z-icon {
  width: calc(var(--space-unit) * 2);
  height: calc(var(--space-unit) * 2);
  padding: 0 calc(var(--space-unit) * 1.5) 0 0;
  background-repeat: no-repeat;
  background-size: contain;
  color: var(--color-primary01);
  fill: var(--color-primary01);
}
